import { useEffect, useState } from "react"
import { DinamicGridCreate, DinamicPageCreate } from "./dinamyc-pages.types"
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import { Button } from '../../../components/Button/Button'
import { useNavigate, useParams } from "react-router-dom"
import { i18n } from "../../../translate/i18n"
import { getAgregadorClassification, getAgregadorStores, uploadImagesInForm, validateForm } from "./factory/dinamic-page.aux"
import { TabInfoPage } from "./components/TabInfoPage"
import { TabGridPage } from "./components/TabGridPage"
import { Loading } from "../../../components/Loading/Loading"
import { useDinamicPages } from "./factory/useDinamicPages"
import { LojaAgregador } from "../lojas/type"
import { AggregatorClassification } from "../AggregadorCategory/aggregadorCategory.type"
import Swal from "sweetalert2"

type fieldsUpdateForm = 'title' | 'description' | 'aggregatorClassificationId' | 'storeId' | 'order' | 'seoTitle' | 'seoDescription' | 'shareImage' | 'slug' | 'status'

export const DinamicPageEditar = () => {

    const navigate = useNavigate()
    const { id } = useParams()
    const { updateAggregatorDinamicPage, getAggregatorDinamicPageById } = useDinamicPages()
    const [stores, setStores] = useState<LojaAgregador[]>([])
    const [classification, setClassification] = useState<AggregatorClassification[]>([])

    const [tab, setTab] = useState<'info' | 'grid'>('info')
    const [blocks, setBlocks] = useState<DinamicGridCreate[]>([])

    const [loadingRequest, setLoadingRequest] = useState(false)
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState<DinamicPageCreate>({
        title: '',
        description: '',
        aggregatorClassificationId: 0,
        storeId: 0,
        order: 0,
        grids: [],
        seoTitle: '',
        seoDescription: '',
        shareImage: '',
        slug: '',
        status: true,
    })

    const updateForm = (field: fieldsUpdateForm, value: string | number | boolean | File) => {
        setForm((prev) => ({ ...prev, [field]: value }))
    }

    async function updatePage() {
        try {
            if (!id) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Id não encontrado',
                    text: 'Não foi possivel encontrar um id valido'
                }).then(() => navigate(-1))
                return
            }

            setLoadingRequest(true)
            const newFormWithGrids: any = {
                ...form,
                grids: blocks.map((b) => ({
                    id: b.id,
                    type: b.type,
                    order: b.order,
                    configuration: b.configuration,
                })),
            }

            if (!validateForm(newFormWithGrids)) {
                setLoadingRequest(false)
                return
            }

            const responseWithImages = await uploadImagesInForm(newFormWithGrids)

            //mesmo se der erro, salvar.
            setForm(responseWithImages.form)

            if (!responseWithImages || !responseWithImages.success) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Uns erros acontenceram ao fazer upload das imagens, deseja prosseguir mesmo assim?',
                    text: responseWithImages.errors.join(',')
                }).then(async () => {
                    await updateAggregatorDinamicPage(parseInt(id), responseWithImages.form)
                })

                return
            }

            // Coloquei any aqui pois grid nao possui ID, então não é possível tipar corretamente, mas o ideal seria tipar corretamente
            await updateAggregatorDinamicPage(parseInt(id), responseWithImages.form)
            navigate(-1)
            console.log('data', newFormWithGrids)
        } catch (error) {
            console.error('Erro ao criar página dinâmica:', error)
        } finally {
            setLoadingRequest(false)
        }
    }

    const tabs = [
        { id: 'info', label: 'Meta Dados da Página', content: <TabInfoPage blockSlug form={form} updateForm={updateForm} stores={stores} classification={classification} /> },
        { id: 'grid', label: 'Grid de Informações', content: <TabGridPage blocks={blocks} setBlocks={setBlocks} /> }
    ]

    async function loadPage() {
        try {
            if (!id) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Id não encontrado',
                    text: 'Não foi possivel encontrar um id valido'
                }).then(() => navigate(-1))
                return
            }
            setLoading(true)
            const page = await getAggregatorDinamicPageById(parseInt(id))

            setForm({storeId:page.data.pluginSpaceAggregatorId,...page.data})
            setBlocks(page.data.grids)

            const [stores, classificaiton] = await Promise.all([getAgregadorStores(), getAgregadorClassification()])


            setStores(stores)
            setClassification(classificaiton)

        } catch (error) {
            console.log(error)
            Swal.fire({
                icon: 'warning',
                title: 'Id não encontrado',
                text: 'Não foi possivel encontrar um id valido'
            }).then(() => navigate(-1))
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadPage()
    }, [])

    if (loading) {
        return <Loading />
    }



    return (
        <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                <div className='card-header py-5 d-flex flex-column'>
                    <div className='d-flex justify-content-between align-items-start flex-wrap gap-4'>
                        <h3 className='card-title align-items-start flex-column mb-0'>
                            <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`agregador_dinamic_page.edit_title`)}</span>
                            <BreadCrumbs />
                            <span className='text-muted mt-1 fw-bold fs-7'>
                                {i18n.t(`agregador_dinamic_page.edit_subTitle`)}
                            </span>
                        </h3>
                    </div>
                </div>
                <section className='card-header border-0 pt-5'>
                    <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
                        {tabs.map((t) => (
                            <li className='nav-item' key={t.id}>
                                <button
                                    className={`nav-link text-active-primary me-6 ${tab === t.id ? 'active' : ''}`}
                                    onClick={() => setTab(t.id as 'info' | 'grid')}
                                >
                                    {t.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </section>
                {tabs.find((t) => t.id === tab)?.content}

                <div className='card-body'>
                    <div className='row ' style={{ marginTop: '14px' }}>
                        <div className='d-flex justify-content-between pb-10 w-100'>
                            <Button
                                text={i18n.t(`buttons.back`)}
                                color='info'
                                size='small'
                                horizontalPadding={6}
                                btnAttr={{
                                    type: 'button',
                                }}
                                click={() => navigate(-1)}
                                btnClass='fw-bolder'
                                disabled={loadingRequest}
                            />
                            <Button
                                text={i18n.t(`buttons.save`)}
                                color='primary'
                                size='small'
                                horizontalPadding={5}
                                btnAttr={{
                                    type: 'button',
                                }}
                                click={() => updatePage()}
                                disabled={loadingRequest}
                                btnClass='fw-bolder'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}